import { render, staticRenderFns } from "./BusyTimeIndicatorThresholdTable.vue?vue&type=template&id=736d6b74&scoped=true&"
import script from "./BusyTimeIndicatorThresholdTable.vue?vue&type=script&lang=js&"
export * from "./BusyTimeIndicatorThresholdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d6b74",
  null
  
)

export default component.exports